(function () {
  function initializeVariantHandling(container = document) {
    const wrappers = container.querySelectorAll('.horizontal-product__wrapper');

    wrappers.forEach(wrapper => {
      const checkbox = wrapper.querySelector('.horizontal-product__checkbox-input');
      const variantSelector = wrapper.querySelector('.variant-selector');

      if (!checkbox) {
        return;
      }

      if (variantSelector) {
        variantSelector.addEventListener('change', () => {
          checkbox.value = variantSelector.value;
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initializeVariantHandling();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initializeVariantHandling(event.target);
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1 && (node.matches('.horizontal-product__wrapper') || node.querySelector('.horizontal-product__wrapper'))) {
            initializeVariantHandling(node);
          }
        });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();